// Copied from apps/voip/src/utils/nicknameAliases.js (origin/master, 2026-10-26) so e-shot
// searches the phone's contacts exactly the way the phone does. The repo rule is
// to copy, never import across apps. Keep in step with the phone's copy.
// Nickname / short-form expansion for contact search.
//
// "Steve" -> "Stephen" is not a prefix and not a phonetic match (S310 vs
// S315) - it's a nickname. We expand the typed token to its known name
// group at QUERY time and search _nameTokens with array-contains-any, so
// no re-indexing or backfill is needed (the full name token is already
// in the index). Curated UK-centric groups; grouping errs towards recall
// because the all-tokens-must-match filter keeps results relevant.
//
// Query-time only - the server-side index builder
// (functions/lib/contact-search-index.js) does NOT need these.

export const NICKNAME_GROUPS = [
  ['stephen', 'steven', 'steve', 'stevie', 'stefan', 'steph'],
  ['william', 'will', 'bill', 'billy', 'willie', 'liam'],
  ['robert', 'rob', 'bob', 'bobby', 'robbie', 'bert'],
  ['richard', 'rich', 'rick', 'ricky', 'dick'],
  ['michael', 'mike', 'mick', 'micky', 'mikey'],
  ['david', 'dave', 'davey'],
  ['james', 'jim', 'jimmy', 'jamie'],
  ['john', 'jon', 'jonathan', 'johnny', 'jack', 'jackie'],
  ['thomas', 'tom', 'tommy'],
  ['anthony', 'tony', 'ant'],
  ['andrew', 'andy', 'drew'],
  ['christopher', 'chris', 'kit'],
  ['christine', 'christina', 'chris', 'chrissie', 'tina'],
  ['katherine', 'catherine', 'kathryn', 'kate', 'katie', 'kathy', 'cathy', 'cath', 'kat'],
  ['elizabeth', 'liz', 'lizzie', 'beth', 'betty', 'libby', 'eliza'],
  ['margaret', 'maggie', 'meg', 'peggy', 'marge'],
  ['jennifer', 'jen', 'jenny'],
  ['susan', 'sue', 'suzanne', 'susie'],
  ['deborah', 'debbie', 'debs', 'deb'],
  ['victoria', 'vicky', 'vicki', 'tori'],
  ['alexander', 'alexandra', 'alex', 'sandy', 'lex', 'sasha'],
  ['samuel', 'samantha', 'sam', 'sammy'],
  ['daniel', 'dan', 'danny'],
  ['matthew', 'matt', 'matty'],
  ['nicholas', 'nick', 'nicky'],
  ['nicola', 'nikki', 'nicky'],
  ['patrick', 'pat', 'paddy'],
  ['patricia', 'pat', 'trish', 'tricia'],
  ['peter', 'pete'],
  ['philip', 'phillip', 'phil'],
  ['raymond', 'ray'],
  ['ronald', 'ron', 'ronnie'],
  ['russell', 'russ'],
  ['sean', 'shaun', 'shawn'],
  ['stephanie', 'steph', 'stef'],
  ['terence', 'terry', 'tel'],
  ['timothy', 'tim', 'timmy'],
  ['trevor', 'trev'],
  ['gareth', 'gaz'],
  ['gary', 'gaz'],
  ['barry', 'baz'],
  ['charles', 'charlie', 'chas', 'chuck'],
  ['charlotte', 'charlie', 'lottie'],
  ['edward', 'ed', 'eddie', 'ted', 'teddy', 'ned'],
  ['francis', 'frank', 'frankie', 'fran'],
  ['frances', 'fran', 'frankie'],
  ['frederick', 'fred', 'freddie'],
  ['gregory', 'greg'],
  ['henry', 'harry', 'hal'],
  ['harold', 'harry'],
  ['jacob', 'jake'],
  ['joseph', 'joe', 'joey'],
  ['joshua', 'josh'],
  ['kenneth', 'ken', 'kenny'],
  ['leslie', 'les'],
  ['louise', 'louisa', 'lou', 'lulu'],
  ['louis', 'lou', 'louie'],
  ['martin', 'martyn', 'marty'],
  ['paul', 'paulo'],
  ['paula', 'pauline'],
  ['rodney', 'rod'],
  ['stanley', 'stan'],
  ['stuart', 'stewart', 'stu'],
  ['vincent', 'vince', 'vinny'],
  ['zachary', 'zach', 'zack', 'zak'],
  ['abigail', 'abby', 'abbie'],
  ['amanda', 'mandy'],
  ['angela', 'angie', 'ange'],
  ['barbara', 'barb', 'babs'],
  ['caroline', 'carolyn', 'carol', 'carrie'],
  ['diane', 'dianne', 'di'],
  ['dorothy', 'dot', 'dottie', 'dolly'],
  ['emily', 'em', 'emmy'],
  ['emma', 'em'],
  ['fiona', 'fi'],
  ['gillian', 'gill', 'jill', 'jillian'],
  ['isabel', 'isabella', 'isabelle', 'izzy', 'bella'],
  ['jacqueline', 'jackie', 'jacqui'],
  ['janet', 'jan', 'janice'],
  ['jessica', 'jess', 'jessie'],
  ['joanne', 'joanna', 'jo'],
  ['julie', 'julia', 'jules'],
  ['kimberley', 'kimberly', 'kim'],
  ['lindsay', 'lindsey', 'linds'],
  ['michelle', 'shell', 'chelle'],
  ['natalie', 'nat'],
  ['natasha', 'nat', 'tash', 'tasha'],
  ['nathan', 'nat', 'nate'],
  ['pamela', 'pam'],
  ['rebecca', 'becky', 'becca', 'bex'],
  ['sarah', 'sara', 'sally'],
  ['sandra', 'sandy'],
  ['sophie', 'sophia', 'soph'],
  ['teresa', 'theresa', 'terri', 'tess'],
  ['tracy', 'tracey'],
  ['valerie', 'val'],
  ['veronica', 'ronnie', 'vron'],
  ['benjamin', 'ben', 'benny'],
  ['bernard', 'bernie'],
  ['bradley', 'brad'],
  ['calvin', 'cal'],
  ['cameron', 'cam'],
  ['colin', 'col'],
  ['craig', 'craigy'],
  ['darren', 'daz'],
  ['dennis', 'den'],
  ['derek', 'del'],
  ['dominic', 'dom'],
  ['donald', 'don', 'donny'],
  ['douglas', 'doug', 'dougie'],
  ['duncan', 'dunc'],
  ['eleanor', 'ellie', 'nell'],
  ['eugene', 'gene'],
  ['gabriel', 'gabriella', 'gabby', 'gabe'],
  ['geoffrey', 'jeffrey', 'geoff', 'jeff'],
  ['gerald', 'gerry', 'jerry'],
  ['gerard', 'gerry'],
  ['gordon', 'gordy'],
  ['graham', 'graeme'],
  ['ian', 'iain'],
  ['jeremy', 'jez', 'jerry'],
  ['jonathan', 'jonny', 'jon'],
  ['julian', 'jules'],
  ['justin', 'jus'],
  ['keith', 'keef'],
  ['kevin', 'kev'],
  ['kirsty', 'kirstie'],
  ['lawrence', 'laurence', 'larry', 'laurie'],
  ['leonard', 'len', 'lenny', 'leo'],
  ['malcolm', 'malc'],
  ['maxwell', 'max'],
  ['maurice', 'morris', 'mo'],
  ['mohammed', 'muhammad', 'mohammad', 'mo'],
  ['neil', 'neal'],
  ['norman', 'norm'],
  ['oliver', 'olly', 'ollie'],
  ['oscar', 'ozzie'],
  ['reginald', 'reg', 'reggie'],
  ['rhys', 'reece', 'reese'],
  ['roger', 'rodge'],
  ['ryan', 'ry'],
  ['sebastian', 'seb'],
  ['sidney', 'sydney', 'sid', 'syd'],
  ['simon', 'si'],
  ['solomon', 'sol'],
  ['theodore', 'theo', 'ted'],
  ['wayne', 'waz'],
  ['zoe', 'zoey'],
];

// token -> Set of every name in its group(s). A token in multiple groups
// (e.g. "nat", "gaz", "pat") unions them - recall over precision.
const ALIAS_MAP = new Map();
for (const group of NICKNAME_GROUPS) {
  for (const name of group) {
    const existing = ALIAS_MAP.get(name) || new Set();
    for (const other of group) existing.add(other);
    ALIAS_MAP.set(name, existing);
  }
}

// Expand a (lowercased) search token to itself + all its nickname
// aliases. Unknown tokens come back as [token].
export function expandNameToken(token) {
  const t = String(token || '').toLowerCase();
  const aliases = ALIAS_MAP.get(t);
  return aliases ? [t, ...[...aliases].filter((a) => a !== t)] : [t];
}
